<template>
  <v-app id="inspire" v-if="isLoggedIn">
    <v-navigation-drawer v-model="drawer" fixed app>
      <v-list dense>
        <v-list-tile :to="{path: '/'}">
          <v-list-tile-action>
            <v-icon>search</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Zoeken</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{path: '/planner/worklist'}">
          <v-list-tile-action>
            <v-icon>schedule</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Planner werklijst</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{path: '/planner/planning'}">
          <v-list-tile-action>
            <v-icon>list</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Planning</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{path: '/mechanic/worklist'}">
          <v-list-tile-action>
            <v-icon>work</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Monteur werklijst</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{path: '/other-lists'}">
          <v-list-tile-action>
            <v-icon>work_off</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Overige lijsten</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-group value="true" prepend-icon="build" v-if="isAdmin" no-action>
          <template v-slot:activator v-on:click.prevent>
            <v-list-tile>
              <v-list-tile-title>Admin</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile :to="{path: '/admin/upload'}">
            <v-list-tile-title>Upload</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>cloud_upload</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{path: '/admin/assignments'}">
            <v-list-tile-title>Opdrachten</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>assignment</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{path: '/admin/to-be-processed'}">
            <v-list-tile-title>Te verwerken</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>assignment_turned_in</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{path: '/admin/clients'}">
            <v-list-tile-title>Klanten</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>folder_shared</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{path: '/admin/nestor'}">
            <v-list-tile-title>Nestor</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>cloud_download</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{path: '/admin/download'}">
            <v-list-tile-title>Download</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>cloud_download</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{path: '/admin/statistics'}" v-if="showStatistics">
            <v-list-tile-title>Statistieken</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>trending_up</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile :to="{path: '/admin/configuration'}" v-if="showStatistics"> <!-- statistics has the same rights -->
            <v-list-tile-title>Configuration</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
        <v-list-tile :to="{path: '/about'}">
          <v-list-tile-action>
            <v-icon>info</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Over...</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar :color="drawerColor" dark fixed app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Infra app</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-start>
          <v-flex xs12 sm10 md8 lg10 text-xs-center>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer :color="drawerColor" app>
      <span class="white--text">&copy; 2017 &dash; {{currentYear}} WeChangedIt</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

import { service } from "./services/user";

export default {
  name: "App",
  data: () => ({
    drawer: null,
    currentYear: new Date().getFullYear(),
    drawerColor: "indigo"
  }),
  computed: {
    ...mapGetters(["isLoggedIn", "isAdmin", "showStatistics"])
  },
  created() {
    service.getUserInfo();
    if (window.location.href.includes("bijna-af.nu")) {
      this.drawerColor = "red";
    }
  }
};
</script>
